<template>
	<v-container
		class="grid-flex-container my-0 py-5"
		style="overflow-y: hidden"
		fluid
	>
		<v-row no-gutters class="mb-2">
			<v-col no-gutters cols="6" class="pr-5">
				<p>
					This page allows you to import formatted data to populate
					the lookup tables. Please upload one of the following:
				</p>
				<ul>
					<li>
						New Excel (.xlsx) - Only the default workbook format is
						supported, not Strict Open XML format
					</li>
					<li>
						Comma Separated File (.csv) - Cells should be separated
						by a comma (not a semicolon!).
					</li>
				</ul>
				<p>
					To update existing records, the applicable IRIS IDs must be
					included in the dataset. Without existing IRIS IDs, new
					records will be created.
				</p>
			</v-col>
			<v-col no-gutters cols="6" class="pl-5">
				<p>Select the destination table for your data:</p>
				<v-select
					dense
					outlined
					v-model="selectedEntity"
					label="Entity"
					:items="entities"
					item-text="Name"
					item-value="Id"
				></v-select>
				<v-row no-gutters>
					<div style="flex-grow: 1">
						<v-select
							class="mr-4"
							dense
							outlined
							label="Templates"
							:items="
								filteredTemplates != null
									? filteredTemplates
									: []
							"
							item-text="Name"
							item-value="Id"
							v-model="selectedTemplate"
							:disabled="hasSelectedEntity"
						></v-select>
					</div>
					<div>
						<v-btn
							v-if="canViewTemplates"
							@click="templatesRedirect"
							class="primary"
							>View All Templates</v-btn
						>
					</div>
				</v-row>
				<p>Select the file that you are importing:</p>
				<v-row no-gutters>
					<v-col>
						<v-file-input
							class="mr-4"
							v-model="file"
							counterlabel="File input"
							placeholder="Select a file"
							prepend-icon="mdi-paperclip"
							dense
							accept=".xlsx,.csv"
							show-size
						/>
					</v-col>
					<v-col cols="3">
						<v-btn
							:disabled="!selectedTemplate || !file"
							v-if="canUpload"
							style="width: 100%"
							@click="submit"
							class="primary"
							>Upload</v-btn
						>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<data-import-files-grid v-if="canView" />
	</v-container>
</template>
<script>
import DataImportFilesGrid from './DataImportFilesGrid.vue';
import { mapGetters } from 'vuex';
import { Permissions } from '../../../enums/permissionsEnum';
import permissionsMixin from '../../../mixins/permissionsMixin';
import { DataImportGetters } from '../../../store/getters';
import { DataImportActions } from '../../../store/actions';
export default {
	components: { DataImportFilesGrid },
	name: 'DataImport',
	mixins: [permissionsMixin],
	data() {
		return {
			file: null,
			gridViews: [],
			selectedEntity: null,
			selectedTemplate: null,
		};
	},
	computed: {
		...mapGetters({
			entities: [DataImportGetters.GET_ENTITIES],
			templates: [DataImportGetters.GET_TEMPLATES],
		}),
		filteredTemplates() {
			if (this.selectedEntity) {
				let result = this.templates.filter(
					(t) => t.EntityId == this.selectedEntity
				);
				return result.sort((a, b) => (a.Name > b.Name ? 1 : -1));
			}
			return null;
		},
		hasSelectedEntity() {
			if (this.selectedEntity) return false;
			return true;
		},
		canViewTemplates() {
			return this.hasPermissions([
				Permissions.Tools.DataImport.Templates.View,
			]);
		},
		canView() {
			return this.hasPermissions([Permissions.Tools.DataImport.View]);
		},
		canUpload() {
			return this.hasPermissions([Permissions.Tools.DataImport.Upload]);
		},
	},
	mounted() {
		this.$store.dispatch(DataImportActions.LOAD);
	},
	destroyed() {
		this.$store.dispatch(DataImportActions.CLEAR);
	},
	methods: {
		submit() {
			let item = {
				file: this.file,
				importFile: { GridViewId: this.selectedTemplate },
			};
			this.$store.dispatch(DataImportActions.INSERT, item).then(() => {
				this.file = null;
			});
		},
		templatesRedirect() {
			this.$router.push({
				name: 'Templates',
			});
		},
	},
};
</script>
